import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutPreviewShippingAddressComponent } from './checkout-preview-shipping-address.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { AddressFormModule } from '@spartacus/user/profile/components';
import { CardModule, FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { AddressCardComponent } from '../../../../misc/address-card/address-card.component';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipIconComponent } from '../../../../../../components/tooltip-icon/tooltip-icon.component';
import { CheckoutAuthGuard } from '../guards/checkout-auth.guard';
import { CartNotEmptyGuard } from '../guards/cart-not-empty.guard';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import { ProductQuantityAllowedGuard } from '../../../_core/product-quantity-allowed.guard';
import { CustomStepValidationGuard } from '../guards/custom-step-validation.guard';

@NgModule({
  declarations: [CheckoutPreviewShippingAddressComponent],
  imports: [
    CommonModule,
    RouterModule,
    AddressFormModule,
    CardModule,
    SpinnerModule,
    I18nModule,
    AddressCardComponent,
    LocalLoaderComponent,
    ReactiveFormsModule,
    TooltipIconComponent,
    FormErrorsModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPreviewShippingAddress: {
          component: CheckoutPreviewShippingAddressComponent,
          guards: [
            CheckoutAuthGuard,
            CartNotEmptyGuard,
            CartValidationGuard,
            ProductQuantityAllowedGuard,
            CustomStepValidationGuard,
          ],
        },
      },
    }),
  ],
})
export class CheckoutPreviewShippingAddressModule {}
